import React from 'react';
import { LoadTile } from '../load-tile';



export const LoadSimilar = React.memo((props: any) => {

    const { module, openMap, showMapId, buyLoadModal, userDetails, loadData } = props;

    return props.loads.map((load: any, index: number) => (
        <div key={index} className={"similar-load-list-web"}>
            <LoadTile
                key={`child_${index}`}
                {...props}
                {...load}
                load={load}
                module={module}
                showMap={showMapId === `child_${index}`}
                setShowMap={(status: boolean) => {
                    openMap(status, `child_${index}`)
                }
                }
                buyLoadModal={buyLoadModal}
                userDetails={userDetails}
                loadData={loadData}
                isCarrierLoad={props.isCarrierLoad}
                rowIndex={index + 1}
                onChangeRowIndex={props.onChangeRowIndex}
                fetchAvailableLoads={props.fetchAvailableLoads}
                toCallExpand={
                    (props.shipmentToExpand &&
                        (props.shipmentToExpand.loadId ||
                            props.shipmentToExpand.shipmentId) ==
                        (load.shipmentId || load.loadId)) ||
                    false
                }
            />
        </div>
    ));
});
